/**
 * Created by Ning Jiang on 2023-09-05.
 */

import {DevilsCrossRoadLayers, Layers} from "./DevilsCrossRoadLayers";
import {gsap, TimelineLite} from "gsap";
import {DevilsCrossRoad} from "../DevilsCrossRoad";

export class StageView {

    private static _mainTl:TimelineLite;

    public static get stage():PIXI.Container {
        return DevilsCrossRoadLayers.getLayer(Layers.BACKGROUND)!.parent!;
    }

    public static startNearWin():void {
        StageView.stopMainTl();
        StageView.playNearWinLoop();
    }

    private static playNearWinLoop():void {
        const tl = gsap.timeline();
        tl.add(StageView.getShakeStageOnceTl(0.3));
        tl.add(() => {
                if(DevilsCrossRoad.scatters.isNearWin) {
                    StageView.playNearWinLoop();
                }
            }
        );
    }

    public static stopNearWin():void {
        StageView.stopMainTl();
    }

    public static getShakeStageOnceTl(factor?:number):TimelineLite {
        if(!factor) {
            factor = 1;
        }
        const tl = gsap.timeline();
        tl.to(StageView.stage, {
            x : (Math.random() * 32 - 16) * factor,
            y : (Math.random() * 16 - 8) * factor,
            duration : 0.02
        })
            .to(StageView.stage, {x : 0, y : 0, duration : 0.03});
        return tl;
    }

    private static stopMainTl():void {
        if(StageView._mainTl && StageView._mainTl.isActive()) {
            StageView._mainTl.progress(1);
            StageView._mainTl.kill();
        }
    }
}